import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Loader2, CheckCircle2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function TeamAccept() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [form, setForm] = useState({ name: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async () => {
    if (form.password.length < 8) return toast.error("Password must be at least 8 characters");
    setBusy(true);
    try {
      await api.post("/team/accept", { token, name: form.name, password: form.password });
      setDone(true);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4" data-testid="team-accept-page">
      <div className="max-w-md w-full rounded-2xl border border-white/10 bg-[#121214] p-8">
        {done ? (
          <div className="text-center">
            <CheckCircle2 className="w-12 h-12 text-emerald-400 mx-auto mb-4" />
            <h1 className="text-xl font-heading text-white mb-2">You're all set!</h1>
            <p className="text-sm text-[#A1A1AA] mb-6">Your team account is active. Sign in to get started.</p>
            <Button onClick={() => navigate("/login")} data-testid="team-accept-login-btn"
              className="fv-gold-gradient text-[#0A0A0B] font-semibold rounded-full w-full">Go to sign in</Button>
          </div>
        ) : !token ? (
          <p className="text-center text-sm text-[#A1A1AA]">This invite link is missing or invalid.</p>
        ) : (
          <>
            <h1 className="text-xl font-heading text-white mb-1">Join your team</h1>
            <p className="text-sm text-[#A1A1AA] mb-6">Set a password to accept your Fairview Systems team invitation.</p>
            <div className="space-y-3">
              <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
                placeholder="Your name" data-testid="team-accept-name" className="bg-[#0d0d0f] border-white/10 text-white" />
              <Input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
                placeholder="Create a password (min 8 chars)" data-testid="team-accept-password" className="bg-[#0d0d0f] border-white/10 text-white" />
              <Button onClick={submit} disabled={busy} data-testid="team-accept-submit"
                className="fv-gold-gradient text-[#0A0A0B] font-semibold rounded-full w-full h-11">
                {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Accept invitation"}
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
